export const ALERT_POSITION_LABELS = {
    center: "Mitte",
    top: "Oben",
    bottom: "Unten",
    "top-left": "Oben links",
    "top-right": "Oben rechts",
    "bottom-left": "Unten links",
    "bottom-right": "Unten rechts",
};
/** With a custom layout, "center" means "exactly where the editor put it" */
export function alertPositionLabel(p, hasLayout) {
    return p === "center" && hasLayout ? "Wie im Layout" : ALERT_POSITION_LABELS[p];
}
